export default __webpack_public_path__ + "static/media/hht2_ep19_timeline_q02_b.fe512c07.png";